/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_StrategyInputs */

const cs_field_strategy = /** @type {(inputs: Field_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const en_field_strategy = /** @type {(inputs: Field_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy`)
};

/**
* | output |
* | --- |
* | "Strategy" |
*
* @param {Field_StrategyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_strategy = /** @type {((inputs?: Field_StrategyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_StrategyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_strategy(inputs)
	return cs_field_strategy(inputs)
});